export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Long type */
  Long: any;
}

export interface ContactInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
}

export interface LocationInput {
  id: Scalars['Int'];
  customerID: Scalars['Long'];
  name: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  locationPhone: Scalars['String'];
  locationFax: Scalars['String'];
}

export interface LocationQl {
  id: Scalars['ID'];
  customerID: Scalars['Long'];
  name: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  zipCode: Scalars['String'];
  state: Scalars['String'];
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
  distance: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstName:Maybe<Scalars['String']>;
  lastName:Maybe<Scalars['String']>;
  email:Maybe<Scalars['String']>;
  cPhone:Maybe<Scalars['String']>;
  cFax:Maybe<Scalars['String']>;
}

export enum LocationType {
  Pharmacy = 'Pharmacy',
  Treatment = 'Treatment',
  Speciality = 'Speciality'
}

export interface Mutation {
  mutateLocation: QlResponse;
}

export interface MutationMutateLocationArgs {
  location?: Maybe<LocationInput>;
  contact?: Maybe<ContactInput>;
  locationType: LocationType;
  productName: ProductName;
  mutationType: MutationType;
}

export enum MutationType {
  New = 'NEW',
  Update = 'UPDATE',
  Remove = 'REMOVE'
}

export enum ProductName {
  Prolia = 'Prolia',
  Evenity = 'Evenity'
}

export interface QlResponse {
  message?: Maybe<Scalars['String']>;
  customerID?: Maybe<Scalars['Long']>;
  statusCode?: Maybe<Scalars['String']>;
}

export interface Query {
  findNearestLocationsByAddress: Array<Maybe<LocationQl>>;
  findNearestLocationsByCoordinates: Array<Maybe<LocationQl>>;
}

export interface QueryFindNearestLocationsByAddressArgs {
  yourAddress: Scalars['String'];
  locationType?: Maybe<LocationType>;
  productName?: Maybe<ProductName>;
  limitLocations?: Maybe<Scalars['Int']>;
  limitDistance?: Maybe<Scalars['Int']>;
}

export interface QueryFindNearestLocationsByCoordinatesArgs {
  longitude: Scalars['String'];
  latitude: Scalars['String'];
  locationType?: Maybe<LocationType>;
  productName?: Maybe<ProductName>;
  limitLocations?: Maybe<Scalars['Int']>;
  limitDistance?: Maybe<Scalars['Int']>;
}
export interface MutateLocationMutationVariables {
  location?: Maybe<LocationInput>;
  contact?: Maybe<ContactInput>;
  locationType: LocationType;
  productName: ProductName;
  mutationType: MutationType;
}

export type MutateLocationMutation = { __typename?: 'Mutation' } & {
  mutateLocation: { __typename?: 'QLResponse' } & Pick<
    QlResponse,
    'statusCode' | 'message' | 'customerID'
  >;
};

export interface FindNearestLocationsByCoordinatesQueryVariables {
  longitude: Scalars['String'];
  latitude: Scalars['String'];
  locationType?: Maybe<LocationType>;
  productName?: Maybe<ProductName>;
  limitLocations?: Maybe<Scalars['Int']>;
  limitDistance?: Maybe<Scalars['Int']>;
}

export type FindNearestLocationsByCoordinatesQuery = {
  __typename?: 'Query';
} & {
  findNearestLocationsByCoordinates: Array<
    Maybe<
      { __typename?: 'LocationQL' } & Pick<
        LocationQl,
        | 'id'
        | 'customerID'
        | 'name'
        | 'address1'
        | 'address2'
        | 'city'
        | 'state'
        | 'zipCode'
        | 'distance'
        | 'phone'
        | 'fax'
        | 'latitude'
        | 'longitude'
		| 'firstName'
		| 'lastName'
		| 'email'
		| 'cPhone'
		| 'cFax'
      >
    >
  >;
};

import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export const MutateLocationDocument = gql`
  mutation mutateLocation(
    $location: LocationInput
    $contact: ContactInput
    $locationType: LocationType!
    $productName: ProductName!
    $mutationType: mutationType!
  ) {
    mutateLocation(
      location: $location
      contact: $contact
      locationType: $locationType
      productName: $productName
      mutationType: $mutationType
    ) {
      statusCode
      message
      customerID
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class MutateLocationGQL extends Apollo.Mutation<
  MutateLocationMutation,
  MutateLocationMutationVariables
> {
  document = MutateLocationDocument;
}
export const FindNearestLocationsByCoordinatesDocument = gql`
  query findNearestLocationsByCoordinates(
    $longitude: String!
    $latitude: String!
    $locationType: LocationType
    $productName: ProductName
    $limitLocations: Int
    $limitDistance: Int
  ) {
    findNearestLocationsByCoordinates(
      longitude: $longitude
      latitude: $latitude
      locationType: $locationType
      productName: $productName
      limitLocations: $limitLocations
      limitDistance: $limitDistance
    ) {
      id
      customerID
      name
      address1
      address2
      city
      state
      zipCode
      distance
      phone
      fax
      latitude
      longitude
	  firstName
	  lastName
	  email,
	  cPhone,
	  cFax,
	  styleclass
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindNearestLocationsByCoordinatesGQL extends Apollo.Query<
  FindNearestLocationsByCoordinatesQuery,
  FindNearestLocationsByCoordinatesQueryVariables
> {
  document = FindNearestLocationsByCoordinatesDocument;
}
